<app-custom-names-tabs objectType="organisation" [objectId]="organisationId"></app-custom-names-tabs>
